class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.modal = this.classList.contains('modal');

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button.cart-notification__close').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    if (this.modal && this.header) {
      this.classList.add('open');
      document.body.classList.add('no-scroll');
    }

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      {once: true}
    );

    document.body.addEventListener('click', this.onBodyClick);

    const updateGlide = new CustomEvent('updateGlide', {
      detail: [
        {
          id: 'cart-shade-upsell'
        }
      ]
    });
    document.dispatchEvent(updateGlide);
  }

  close() {
    this.notification.classList.remove('active');
    if (this.modal) {
      this.classList.remove('open');
      document.body.classList.remove('no-scroll');
    }
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  /*
    Dev servers don't always return the section in the cart response
    If they're not returned we manually fetch them
    See: https://github.com/Shopify/shopify-cli/issues/1797#issuecomment-1153484659
  */
  async renderContents(parsedState) {
    this.cartItemKey = parsedState.key ? parsedState.key : parsedState.items[0].key;
    // Fetch missing sections in development environments
    if (!parsedState.sections) {
      const sections = await fetch(
        `${routes.cart_url}?sections=${this.getSectionsToRender().map((section) => section.id)}`
      );
      parsedState.sections = await sections.json();
    }
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });
    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
